var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-stat px-5 py-3",staticStyle:{"border":"thin solid rgba(100, 100, 100)","border-radius":"4px"}},[_c('div',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"font-weight-bold text-h5"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }